let ladda = {
  bind: function (el, binding, vnode) {
    $(el).attr("data-style", "slide-left");
    Ladda.bind(el);
  }
};

export default ladda;